<template>
  <div class="content">
    <div class="content-class">
      <p class="content-title">投诉信息</p>
      <div class="neir-class">
        <el-descriptions  :column="2" >
            <el-descriptions-item label="投诉单号" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.complaintId}}</el-descriptions-item>
            <el-descriptions-item label="投诉时间" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.complaintTime}}</el-descriptions-item>
            <el-descriptions-item label="投诉金额" label-class-name="complaint-info-label" content-class-name="complaint-info-content"><span style="color: #67C23A;">{{complaintInformation.amount}}</span></el-descriptions-item>
            <el-descriptions-item label="已退款金额" label-class-name="complaint-info-label" content-class-name="complaint-info-content"><span style="color: #F56C6C;">{{complaintInformation.refundAmount}}</span></el-descriptions-item>
            <el-descriptions-item label="问题类型" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.problemDescription}}</el-descriptions-item>
            <el-descriptions-item label="ICCID" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                <el-link type="primary" :underline="false" style="font-size: 18px;" @click="info(complaintInformation.iccid)">{{complaintInformation.iccid}}</el-link>
            </el-descriptions-item>
            <el-descriptions-item label="联系方式" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.phone}}</el-descriptions-item>
            <el-descriptions-item label="投诉次数" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.userComplaintTimes}}</el-descriptions-item>
            <el-descriptions-item label="投诉单状态" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                <el-tag type="danger" size="mini" v-if="complaintInformation.complaintState == '待处理'">待处理</el-tag>
                <el-tag type="success" size="mini" v-else-if="complaintInformation.complaintState == '已完成'">已完成</el-tag>
                <el-tag type="warning" size="mini" v-else-if="complaintInformation.complaintState == '处理中'">处理中</el-tag>
                <el-tag type="danger" size="mini" v-else>{{complaintInformation.complaintState}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="操作结束时间" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                {{complaintInformation.finishTime}}
            </el-descriptions-item>
            <el-descriptions-item label="被投诉商户号" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.mchId}}</el-descriptions-item>
            <el-descriptions-item label="被投诉商户" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.mchName}}</el-descriptions-item>
            <el-descriptions-item label="支付订单号" label-class-name="complaint-info-label" content-class-name="complaint-info-content">{{complaintInformation.orderNum}}</el-descriptions-item>
            <el-descriptions-item label="外部订单号" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                {{complaintInformation.transactionId}}
            </el-descriptions-item>
            <el-descriptions-item label="是否已全额退款" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                <el-tag type="danger" size="mini" v-if="complaintInformation.complaintFullRefunded == '1'">是</el-tag>
                <el-tag type="success" size="mini" v-else>否</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="待回复留言" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                <el-tag type="danger" size="mini" v-if="complaintInformation.incomingUserResponse == '1'">有</el-tag>
                <el-tag type="success" size="mini" v-else>无</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="需即时服务用户" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                <el-tag type="danger" size="mini" v-if="complaintInformation.needImmediateService == '1'">是</el-tag>
                <el-tag type="success" size="mini" v-else>否</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="是否开发票" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                <el-tag type="danger" size="mini" v-if="complaintInformation.isInvoice == '1'">是</el-tag>
                <el-tag type="success" size="mini" v-else>否</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="投诉内容" label-class-name="complaint-info-label" content-class-name="complaint-info-content">
                {{complaintInformation.complaintDetail}}
            </el-descriptions-item>
        </el-descriptions>
      </div>
      <p class="content-title" v-if="complaintInformation.userComplaintImg.length>0">用户图片</p>
      <div class="neir-class" v-if="complaintInformation.userComplaintImg.length>0">
        <el-image style="width: 100px; height: 100px;margin-right: 40px;" v-for="(item, index) in complaintInformation.userComplaintImg" :key="index" :src="item" fit="fill" :preview-src-list="complaintInformation.userComplaintImg" ></el-image>
      </div>
      <p class="content-title">投诉进展</p>
      <div class="progress-class">
        <el-steps :active="complaintInformation.complaintStep" finish-status="success" align-center>
          <el-step title="用户发起投诉"></el-step>
          <el-step title="待处理"></el-step>
          <el-step title="处理中"></el-step>
          <el-step title="已处理完成"></el-step>
        </el-steps>
      </div>
      <p class="content-title">
        <span>协商历史</span>
      </p>
      <div style="margin-top: 30px;padding-bottom: 30px;">
        <el-table :data="tableData" border>
          <el-table-column prop="operateTime" label="用户提交时间" align="center" width="200px"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="200px"></el-table-column>
          <el-table-column prop="updateTime" label="接入时间" align="center" width="200px">
            <template slot-scope="scope">
              <p>{{scope.row.updateTime}}</p>
              <p>{{scope.row.viewUser}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="角色" align="center" width="120px" ></el-table-column>
          <el-table-column prop="operateTypeDesc" label="操作简介" align="center" width="220px"></el-table-column>
          <el-table-column prop="answerName" label="操作人" align="center" width="120px"></el-table-column>
          <el-table-column prop="operateDetails" label="内容" align="center"></el-table-column>
          <el-table-column  prop="images" label="附件" align="center" width="80px">
            <template slot-scope="scope">
              <el-image v-if="scope.row.images && scope.row.images.length>0" style="width: 30px; height: 30px;"  :src="scope.row.images[0]" :preview-src-list="scope.row.images" fit="fill"></el-image>
              <span v-else>无</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form :model="from" ref="from" :rules="ruleValidate">
        <el-form-item label="反馈类目"  prop="feedbackCode" :label-width="LabelWidth" v-if="complaintInformation.type=='2'">
          <el-select v-model="from.feedbackCode" placeholder="请选择反馈类目" v-if="complaintInformation.channel=='1'">
            <el-option label="使用体验保障金退款" value="00"></el-option>
            <el-option label="通过其他方式退款" value="02"></el-option>
            <el-option label="已发货" value="03"></el-option>
            <el-option label="其他" value="04"></el-option>
            <el-option label="已完成售后服务" value="05"></el-option>
            <el-option label="非我方责任范围" value="06"></el-option>
          </el-select>
          <el-select v-model="from.feedbackCode" placeholder="请选择反馈类目" v-if="complaintInformation.channel=='2'">
            <el-option label="已联系到用户，协商一致，无异议" value="CONSENSUS_WITH_CLIENT"></el-option>
            <el-option label="其他" value="ORTHER"></el-option>
            <el-option label="不涉及退款，已针对投诉内容进行整改" value="RECTIFICATION_NO_REFUND"></el-option>
            <el-option label="已退款，用户无异议" value="REFUND"></el-option>
            <el-option label="已提交证明材料" value="SUBMIT_PROOF_NOT_CONTACTED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回复内容：" prop="message" :label-width="LabelWidth">
          <el-input type="textarea" :rows="6" v-model="from.message" style="width: 45%;" placeholder="请输入回复内容" @input="descInput" maxlength="200"></el-input>
          <span style="position: relative;top: 6px;left: -55px;">{{txtVal}}/200</span>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="saveDialog('from')" style="margin: 0 0 50px 95px;">提交</el-button>
    </div>
  </div>
</template>
<script>
import { complainDetail } from "@/api/api.js"; //微信投诉详情
import { complainConsultList } from "@/api/api.js"; //微信投诉协商历史
import { complainAnswerComplaint } from "@/api/api.js"; //微信投诉消息回复
export default {
  data() {
    return{
      type:"1",
      tableData:[],
      dialogVisible:false,
      from:{},
      LabelWidth: "100px",
      ruleValidate:{
        message: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
          { min: 10,max: 200,message: "请输入10至200字的内容",trigger: "blur" },
        ],
        feedbackCode: [
          { required: true, message: "请选择反馈类目", trigger: "blur" }
        ],
      },
      txtVal:0,
      complaintInformation:{
        userComplaintImg:[]
      }
    }
  },
  methods: {
    // 详情
    info(iccid) {
      if(this.type == "2"){
        this.$router.push({path:"/international/internationalDetail",query:{iccid: iccid}});
      } else {
        this.$router.push({path:"/card/detail",query:{iccid: iccid}});
      }
    },
    // 获取列表的数据
    initData(){
      let params = {
        complaintId:this.$route.params && this.$route.params.complaintId
      };
      complainDetail(params).then(res=>{
        if (res.data.code == 200) {
          this.complaintInformation = res.data.data;
          this.complaintInformation.complaintStep = + this.complaintInformation.complaintStep;
          if(this.complaintInformation.complaintState == "2"){
            this.complaintInformation.complaintState = "待处理";
          }else if(this.complaintInformation.complaintState == "3"){
            this.complaintInformation.complaintState = "处理中";
          }else{
            this.complaintInformation.complaintState = "已完成";
          }
        }
      });
      complainConsultList(params).then(res=>{
        this.tableData = res.data.data;
      })
    },
    // 消息回复提交
    saveDialog(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            complaintId:this.complaintInformation.complaintId,
            msg:this.from.message,
            feedbackCode:this.from.feedbackCode
          }
          complainAnswerComplaint(params).then(res=>{
            if (res.data.code == 200) {
              this.$message.success("回复成功");
              this.initData()
              this.from.message  = '';
            }
          })
        }
      })
    },
    // 监听输入内容的长度
    descInput(){
      this.txtVal = this.from.message.length;
    },
  },
  mounted() {
    this.initData()
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
::v-deep .complaint-info-label{
    font-size: 18px;
    color: #999;
    line-height: 30px;
    display: inline-block;
    width: 150px;
    text-align: left;
}
::v-deep .complaint-info-content{
    font-weight: 500;
    color: #333;
    font-size: 18px;
    line-height: 30px;
    display: inline-block;
    text-align: left;
}
.content-class{
  .content-title{
    border-left: 3px solid #00c250;
    font-size: 18px;
    padding-left: 10px;
    font-weight: 600;
    line-height: 16px;
    display: inline-block;
    margin-top: 20px;
  }
  .neir-class{
    padding: 20px 30px;
    
    .nrxq-class{
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      height: 50px;
      line-height: 50px;
      div{
        width: 50%;
        margin-left: 30px;
        font-size: 16px;
        .zb-class{
          color: #999;
          display: inline-block;
          width: 128px;
          text-align: left;
        }
        .yb-class{
          font-weight: 540;
          color: #333;
          vertical-align: baseline;
        }
      }
    }
  }
  .progress-class{
    width: 70%;
    margin-top: 20px;
    margin-left:30px;
  }
}
/deep/ .el-textarea__inner{
  resize:none;
}
</style>


